import request from '../utils/request';

export const purchaseAndDynamicsApi = {
  // 获取求购列表
  getPurchaseList: (params) => {
    return request({
      url: '/purchase/list',
      method: 'get',
      params: {
        title: params.title,
        contactName: params.contactName,
        status: params.status,
        startTime: params.startTime,
        endTime: params.endTime,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建求购
  createPurchase: (data) => {
    return request({
      url: '/purchase/create',
      method: 'post',
      data
    });
  },

  // 更新求购
  updatePurchase: (id, data) => {
    return request({
      url: `/purchase/update/${id}`,
      method: 'put',
      data
    });
  },

  // 删除求购
  deletePurchase: (id) => {
    return request({
      url: `/purchase/delete/${id}`,
      method: 'delete'
    });
  },

  // 获取动态列表
  getDynamicsList: (params) => {
    return request({
      url: '/dynamics/list',
      method: 'get',
      params: {
        title: params.title,
        author: params.author,
        status: params.status,
        startTime: params.startTime,
        endTime: params.endTime,
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 创建动态
  createDynamic: (data) => {
    // 如果是 FormData，直接发送
    if (data instanceof FormData) {
      return request({
        url: '/dynamics/create',
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data
      });
    }
    
    // 如果是普通对象，转换为 FormData
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    
    return request({
      url: '/dynamics/create',
      method: 'post',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    });
  },

  // 更新动态
  updateDynamic: (id, data) => {
    // 如果是 FormData，直接发送
    if (data instanceof FormData) {
      return request({
        url: `/dynamics/update/${id}`,
        method: 'put',
        headers: { 'Content-Type': 'multipart/form-data' },
        data
      });
    }
    
    // 如果是普通对象，转换为 FormData
    const formData = new FormData();
    Object.keys(data).forEach(key => {
      formData.append(key, data[key]);
    });
    
    return request({
      url: `/dynamics/update/${id}`,
      method: 'put',
      headers: { 'Content-Type': 'multipart/form-data' },
      data: formData
    });
  },

  // 删除动态
  deleteDynamic: (id) => {
    return request({
      url: `/dynamics/delete/${id}`,
      method: 'delete'
    });
  },

  // 获取动态评论列表
  getCommentList: (type, id, params) => {
    return request({
      url: `/${type}/comments/${id}`,
      method: 'get',
      params: {
        page: params.page,
        pageSize: params.pageSize
      }
    });
  },

  // 添加评论
  addComment: (type, id, data) => {
    return request({
      url: `/${type}/comments/${id}`,
      method: 'post',
      data
    });
  },

  // 删除评论
  deleteComment: (type, id, commentId) => {
    return request({
      url: `/${type}/comments/${id}/${commentId}`,
      method: 'delete'
    });
  }
}; 